import { createSurveyStyles } from '@sm/webassets';
import { SurveyThemeType } from '@sm/webassets/dist/components/SurveyTheme';
import { WrenchTheme } from '@wds/styles';

type StyleNames = 'selectContainer' | 'selectOption';

const useStyles = createSurveyStyles<StyleNames>((theme: SurveyThemeType) => {
  return {
    selectContainer: {
      border: 'none',
      overflow: 'auto',
      borderRadius: 0,
      '&:focus-within, &:hover': {
        border: 'none',
        outline: 'none',
      },
      color: ` ${theme.titleColor}`,
      '& select': {
        backgroundColor: 'transparent',
        fontSize: 12,
        fontWeight: 400,
        fontFamily: WrenchTheme.type.fontFamily.base,
        borderRadius: 0,
        paddingRight: 26,
        '&:focus-within, &:hover': {
          border: `1px solid ${theme.titleColor}`,
        },
      },
      '& svg': {
        width: '10px',
        margin: '0 6px 0px 0px',
      },
    },
    selectOption: {
      fontFamily: WrenchTheme.type.fontFamily.base,
    },
  };
});

export default useStyles;
